import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Button, buttonVariants } from '@/shared/ui';

interface ReviewPageNoticeProps {
  /** 불러오는 중이면 status, 안내·오류면 alert 로 읽힌다. */
  readonly kind: 'loading' | 'info' | 'error';
  readonly message: string;
  readonly link?: { readonly to: string; readonly label: string };
  readonly onRetry?: () => void;
}

/** 후기 쓰기·수정 화면이 폼 대신 보여 주는 한 줄 안내 — 로딩, 쓸 수 없는 이유, 불러오기 실패. */
export const ReviewPageNotice = ({
  kind,
  message,
  link,
  onRetry,
}: ReviewPageNoticeProps): ReactElement => (
  <div
    role={kind === 'loading' ? 'status' : 'alert'}
    className="mt-8 flex max-w-2xl flex-col items-start gap-4 text-sm"
  >
    <p className={kind === 'error' ? 'text-destructive' : 'text-muted-foreground'}>{message}</p>
    {link !== undefined && (
      <Link to={link.to} className={buttonVariants({ variant: 'outline', size: 'sm' })}>
        {link.label}
      </Link>
    )}
    {onRetry !== undefined && (
      <Button type="button" variant="outline" size="sm" onClick={onRetry}>
        다시 시도
      </Button>
    )}
  </div>
);
